/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Audio_Format_LabelInputs */



/**
* | output |
* | --- |
* | "Audio Format" |
*
* @param {Audio_Description_Export_Audio_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_audio_format_label = /** @type {((inputs?: Audio_Description_Export_Audio_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Audio_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioformat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиоформат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオフォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato de áudio")
	return /** @type {LocalizedString} */ ("Audio Format")
});